import {
    API_REQUEST,
    CREATE_PLANT_SUCCESS,
    CREATE_PLANT_FAILURE,
    GET_PLANT_SUCCESS,
    GET_PLANT_UNIT_SUCCESS,
    GET_PLANT_FAILURE,
    GET_PLANT_FILTER_LIST,
    GET_COMPANY_SELECTLIST,
    GET_PLANT_CODE_SELECT_LIST
} from '../../../config/constants';

const initialState = {

};

export default function plantReducer(state = initialState, action) {
    switch (action.type) {
        case API_REQUEST:
            return {
                ...state,
                loading: true
            };
        case CREATE_PLANT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: true,
            };
        case CREATE_PLANT_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            };
        case GET_PLANT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: true,
                plantDetail: action.payload
            };
        case GET_PLANT_UNIT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: true,
                plantUnitDetail: action.payload
            };
        case GET_PLANT_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            };
        case GET_PLANT_FILTER_LIST:
            let arr = []
            arr = action.payload && action.payload.filter((el, i) => {
                el.status = el.IsActive
                if (el.status === true) {
                    el.status = 'Active'
                } else if (el.status === false) {
                    el.status = 'In Active'
                }
                return true
            })
            return {
                ...state,
                loading: false,
                error: true,
                plantDataList: arr
            }
        case GET_COMPANY_SELECTLIST:
            return {
                ...state,
                loading: false,
                error: true,
                companySelectList: action.payload
            }
        case GET_PLANT_CODE_SELECT_LIST:
            return {
                ...state,
                loading:false,
                error:true,
                plantCodeSelectList:action.payload
            }

        default:
            return state;
    }
}
